import script from "./MemberUploadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberUploadModal.vue?vue&type=script&setup=true&lang=ts"

import "./MemberUploadModal.vue?vue&type=style&index=0&id=47d2b7f6&lang=scss"

const __exports__ = script;

export default __exports__